import { PageLoader } from '@/shared/ui';
import { Outlet } from 'react-router-dom';
import { useGetProjectDataQuery } from '@/entities/layout';
import { useProjectSiteParams } from '@/shared/lib';

export const ProjectSiteLoader = () => {
  const { projectId, siteId, isValid } = useProjectSiteParams();

  const { isLoading, error } = useGetProjectDataQuery(
    { projectId, siteId },
    {
      skip: !isValid || !projectId || !siteId
    }
  );

  if (isLoading) {
    return <PageLoader messageKey="common.loadingProject" />;
  }

  if (error) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center text-destructive">
          <p>Failed to load project data</p>
          <p className="text-sm text-muted-foreground mt-1">Please check the URL or try refreshing</p>
        </div>
      </div>
    );
  }

  return <Outlet />;
};
